// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sIku","question":"styles_question__3oqrC","inputVisibleButton":"styles_inputVisibleButton__eMjVm","note":"styles_note__36iTX"};